"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SIDEBAR_IMPLICIT_ENVIRONMENT_CONFIG = exports.DEFAULT_SIDEBAR_HIDDEN_ENVIRONMENTS = void 0;
const types_1 = require("../../server/llm/types");
exports.DEFAULT_SIDEBAR_HIDDEN_ENVIRONMENTS = [
    types_1.LangfuseInternalTraceEnvironment.PromptExperiments,
    types_1.LangfuseInternalTraceEnvironment.LLMJudge,
    types_1.LangfuseInternalTraceEnvironment.CodeEval,
    types_1.LangfuseInternalTraceEnvironment.NaturalLanguageFilter,
    "langfuse-evaluation",
    "sdk-experiment",
];
exports.DEFAULT_SIDEBAR_IMPLICIT_ENVIRONMENT_CONFIG = {
    hiddenEnvironments: exports.DEFAULT_SIDEBAR_HIDDEN_ENVIRONMENTS,
};
